import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { MtmaModule } from 'src/app/model/mtma-module';
import * as DeviceActions from 'src/app/store/device/device.actions';
import {
	MTMA_SECTION_ADD, MTMA_SECTION_EDIT_MTM_8C, MTMA_SECTION_EDIT_MTM_AC,
	MTMA_SECTION_EDIT_MTM_BFVS, MTMA_SECTION_EDIT_MTM_DY, MTMA_SECTION_EDIT_MTM_INFO,
	MTMA_SECTION_EDIT_MTM_KB, MTMA_SECTION_EDIT_MTM_RFID, MTMA_SECTION_LIST_MTM_KB,
	MTMA_SECTION_LIST_MTM_RFID,
	MtmaModuleType,
	listModuleMtma
} from 'src/app/conf/mtma-module';
import { environment } from 'src/environments/environment';
import { selectFirmwareUpdate, selecMtmaModules, selectCurrentDevice, selectCurrentDeviceStatus, selectMtmaActiveTask, selectAutomationsFirmwaresList, selectCurrentDeviceModel, selectMtmaFwAutoUpdateTimeslot } from 'src/app/store/device/device.selector';
import { selectUser } from 'src/app/store/user/user.selector';
import { Observable, Subscription, filter } from 'rxjs';
import { ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { EDeviceMtmaModel, isMtmacUsModel } from 'src/app/conf/device-models';
import { MtmaTask } from 'src/app/model/mtma-task';
import { selectIsImpersMode, selectRoleExplainedTechnician } from 'src/app/store/user/user.selector';
import { DeviceStatus } from 'src/app/model/device-status';
import { Firmware, FirmwaresCategory, FirmwareUpdate } from 'src/app/model/firmware-update';
import { TranslateService } from '@ngx-translate/core';
import { CLOUD_FW_UPGRADE_STATE } from 'src/app/conf/firmware-upgrade';
import { UpdateFirmwareDialogComponent } from '../update-firmware-dialog/update-firmware.dialog.component';
import { MtmaManageModuleAddComponent } from '../mtma-manage-module-add/mtma-manage-module-add.component';
import { MtmaManageModuleAcComponent } from '../mtma-manage-module-ac/mtma-manage-module-ac.component';
import { MtmaManageModuleDyComponent } from '../mtma-manage-module-dy/mtma-manage-module-dy.component';
import { MtmaManageModuleBfvsComponent } from '../mtma-manage-module-bfvs/mtma-manage-module-bfvs.component';
import { MtmaManageModule8CComponent } from '../mtma-manage-module-8c/mtma-manage-module-8c.component';
import { MtmaManageModuleInfoComponent } from '../mtma-manage-module-info/mtma-manage-module-info.component';
import { MtmaManageModuleKbComponent } from '../mtma-manage-module-kb/mtma-manage-module-kb.component';
import { MtmaManageModuleRfidComponent } from '../mtma-manage-module-rfid/mtma-manage-module-rfid.component';
import { StandardMtmaLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { selectDeviceTabIndex } from 'src/app/store/home/home.selector';
import { DeviceModel } from 'src/app/model/device-model';
import { Device, MtmaIndexTab } from 'src/app/model/device';
import { User } from 'src/app/model/user';
import { MtmaFwAutoUpdateTimeslot } from 'src/app/model/mtma-fw-autoupdate-timeslot';
import { ReleaseNoteDeviceDialogComponent } from 'src/app/modules/shared/components/release-note-device-dialog/release-note-device.dialog.component';
import { UpdateFirmwareTimeslotsDialogComponent } from '../update-firmware-timeslots-dialog/update-firmware-timeslots.dialog.component';

@Component({
	selector: 'app-mtma-manage-module',
	templateUrl: './mtma-manage-module.component.html',
	providers: [ConfirmationService, DialogService],
	styles: `
		img {
			-webkit-user-drag: none;
			user-drag: none;
		}
	`
})

export class MtmaManageModuleComponent implements OnInit, OnDestroy {
	mtmaModules$: Observable<MtmaModule[] | undefined>;
	mtmaModulesSub: Subscription | undefined;
	mtmaActiveTask$: Observable<MtmaTask | undefined>;
	mtmaActiveTaskSub: Subscription | undefined;
	impersMode$: Observable<boolean | undefined>;
	impersModeSub: Subscription | undefined;
	isTechnician$: Observable<boolean | undefined>;
	isTechnicianSub: Subscription | undefined;
	deviceStatus$: Observable<DeviceStatus | undefined>;
	deviceStatusSub: Subscription | undefined;
	firmwareUpdate$: Observable<FirmwareUpdate[] | undefined>;
	firmwareUpdateSub: Subscription | undefined;
	tabIndex: number;
	tabIndex$: Observable<number | undefined>;
	tabIndexSub: Subscription | undefined;
	automationsFirmwaresList$: Observable<FirmwaresCategory | undefined>;
	automationsFirmwaresListSub: Subscription | undefined;
	deviceModel$: Observable<DeviceModel | undefined>;
	deviceModelSub: Subscription | undefined;
	currentDevice$: Observable<Device | undefined>;
	currentDeviceSub: Subscription | undefined;
	user$: Observable<User | undefined>;
	userSub: Subscription | undefined;
	mtmaFwAutoUpdateTimeslot$: Observable<MtmaFwAutoUpdateTimeslot | undefined>;
	mtmaFwAutoUpdateTimeslotSub: Subscription | undefined;

	sectionVisible: string;
	mtmaModules: MtmaModule[] = [];
	deviceStatus: DeviceStatus;
	mtmaFirmwareUpdates: FirmwareUpdate[] = [];
	deviceModel: DeviceModel;

	automationsFirmwaresList: FirmwaresCategory;

	mtmaFwAutoUpdateTimeslot?: MtmaFwAutoUpdateTimeslot; // if undefined, the auto-update is disabled
	private deviceId: number | undefined;
	private userId: number | undefined;

	isActiveTask = false;
	isTechnician = false;
	isImpersMode = false;

	ref: DynamicDialogRef | undefined;

	acceptButtonStyle: string;
	rejectButtonStyle: string;

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		public confirmationService: ConfirmationService,
		private translate: TranslateService,
		public dialogService: DialogService,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		this.mtmaModules$ = this.store.select(selecMtmaModules);
		this.mtmaActiveTask$ = this.store.select(selectMtmaActiveTask);
		this.impersMode$ = this.store.select(selectIsImpersMode);
		this.isTechnician$ = this.store.select(selectRoleExplainedTechnician);
		this.deviceStatus$ = this.store.select(selectCurrentDeviceStatus);
		this.firmwareUpdate$ = this.store.select(selectFirmwareUpdate);
		this.tabIndex$ = this.store.select(selectDeviceTabIndex);
		this.automationsFirmwaresList$ = this.store.select(selectAutomationsFirmwaresList);
		this.deviceModel$ = this.store.select(selectCurrentDeviceModel);
		this.currentDevice$ = this.store.select(selectCurrentDevice);
		this.user$ = this.store.select(selectUser);
		this.mtmaFwAutoUpdateTimeslot$ = this.store.select(selectMtmaFwAutoUpdateTimeslot);
	}

	ngOnInit(): void {
		this.sectionVisible = '';
		let test = false;
		if (environment.apiUrl !== 'https://app.cameconnect.net/api') {
			test = true;
		}
		this.store.dispatch(DeviceActions.getMtmaModules());
		this.store.dispatch(DeviceActions.getMtmaSettingsModules());
		this.store.dispatch(DeviceActions.resetFirmwareUpdate());
		this.store.dispatch(DeviceActions.getFirmwareUpdate({ test }));

		this.subscribeAll();
		this.onResize();
	}

	ngOnDestroy(): void {
		this.mtmaModulesSub?.unsubscribe();
		this.mtmaActiveTaskSub?.unsubscribe();
		this.impersModeSub?.unsubscribe();
		this.isTechnicianSub?.unsubscribe();
		this.firmwareUpdateSub?.unsubscribe();
		this.deviceStatusSub?.unsubscribe();
		this.tabIndexSub?.unsubscribe();
		this.automationsFirmwaresListSub?.unsubscribe();
		this.deviceModelSub?.unsubscribe();
		this.currentDeviceSub?.unsubscribe();
		this.userSub?.unsubscribe();
		this.mtmaFwAutoUpdateTimeslotSub?.unsubscribe();
	}


	subscribeAll(): void {
		this.deviceModelSub = this.deviceModel$?.subscribe(
			(deviceModel) => {
				this.deviceModel = deviceModel;
			}
		);
		this.automationsFirmwaresListSub = this.automationsFirmwaresList$?.subscribe(
			(automationsFirmwaresList) => {
				this.automationsFirmwaresList = automationsFirmwaresList;
			}
		);
		this.deviceStatusSub = this.deviceStatus$.pipe(filter(d => !!d))
			.subscribe(currentDeviceStatus => {
				this.deviceStatus = currentDeviceStatus;
			});
		this.mtmaModulesSub = this.mtmaModules$.subscribe(mtmaModules => {
			this.mtmaModules = mtmaModules;
		});
		this.isTechnicianSub = this.isTechnician$.subscribe((isTechnician => {
			this.isTechnician = isTechnician;
		}));
		this.impersModeSub = this.impersMode$.subscribe((isImpersMode => {
			this.isImpersMode = isImpersMode;
		}));
		this.firmwareUpdateSub = this.firmwareUpdate$.subscribe(mtmaFirmwareUpdates => {
			this.mtmaFirmwareUpdates = mtmaFirmwareUpdates.filter(fir => fir.AvailableFWVersion);
		});
		this.mtmaActiveTaskSub = this.mtmaActiveTask$.subscribe(mtmaActiveTask => {
			if (mtmaActiveTask.Id !== '') {
				this.isActiveTask = true;
			} else {
				this.isActiveTask = false;
			}
		});
		this.tabIndexSub = this.tabIndex$?.subscribe(
			async (tabIndex: number) => {
				this.tabIndex = tabIndex;
				this.getMtmaModulesData();
			});
		this.currentDeviceSub = this.currentDevice$
			.pipe(filter((d): d is Device => !!d?.Id))
			.subscribe((device) => {
				this.deviceId = device.Id;
				this.tryRequestMtmaFwAutoUpdateTimeslots();
			});
		this.userSub = this.user$
			.pipe(filter((u): u is User => u != null && u.Id != null))
			.subscribe((user) => {
				this.userId = user.Id as number;
				this.tryRequestMtmaFwAutoUpdateTimeslots();
			});
		this.mtmaFwAutoUpdateTimeslotSub = this.mtmaFwAutoUpdateTimeslot$?.subscribe((slot) => {
			this.mtmaFwAutoUpdateTimeslot = slot;
		});
	}

	private tryRequestMtmaFwAutoUpdateTimeslots(): void {
		if (this.deviceId == null || this.userId == null) {
			return;
		}
		if (!this.isSelectTab()) {
			return;
		}
		this.store.dispatch(
			DeviceActions.getMtmaFwAutoUpdateTimeslots({ deviceId: this.deviceId, userId: this.userId }),
		);
	}

	isShowAddSection(): boolean {
		return this.sectionVisible === MTMA_SECTION_ADD;
	}

	isShowEditMtmRfid(): boolean {
		return this.sectionVisible === MTMA_SECTION_EDIT_MTM_RFID;
	}

	isShowEditMtmKb(): boolean {
		return this.sectionVisible === MTMA_SECTION_EDIT_MTM_KB;
	}

	isShowEditMtmInfo(): boolean {
		return this.sectionVisible === MTMA_SECTION_EDIT_MTM_INFO;
	}
	isShowEditMtmBfvs(): boolean {
		return this.sectionVisible === MTMA_SECTION_EDIT_MTM_BFVS;
	}
	isShowEditMtmAc(): boolean {
		return this.sectionVisible === MTMA_SECTION_EDIT_MTM_AC;
	}
	isShowEditMtm8c(): boolean {
		return this.sectionVisible === MTMA_SECTION_EDIT_MTM_8C;
	}
	isShowEditMtmDy(): boolean {
		return this.sectionVisible === MTMA_SECTION_EDIT_MTM_DY;
	}

	isShowListMtmRfid(): boolean {
		return this.sectionVisible === MTMA_SECTION_LIST_MTM_RFID;
	}

	isShowListMtmMkb(): boolean {
		return this.sectionVisible === MTMA_SECTION_LIST_MTM_KB;
	}

	getModuleName(module: MtmaModule): string {
		const moduleDef = listModuleMtma.find(m => m.Type === module.Type);
		return moduleDef.Name;
	}

	visibleFWVersionBl(module: MtmaModule): boolean {
		switch (module.Type) {
			case EDeviceMtmaModel.MODULETYPE_MTMRFID:
				return true;
			case EDeviceMtmaModel.MODULETYPE_MTMKB:
				return false;
			case EDeviceMtmaModel.MODULETYPE_MTMINFO:
				return false;
			case EDeviceMtmaModel.MODULETYPE_MTMAC:
				return true;
			case EDeviceMtmaModel.MODULETYPE_MTM8C:
				return false;
			case EDeviceMtmaModel.MODULETYPE_MTMBFVS:
				return true;
			case EDeviceMtmaModel.MODULETYPE_MTMDY:
				return true;
			default:
				return false;
		}
	}

	// valid also for automatic update firmare information
	visibleFWVersionLte(module: MtmaModule): boolean {
		switch (module.Type) {
			case EDeviceMtmaModel.MODULETYPE_MTMRFID:
				return false;
			case EDeviceMtmaModel.MODULETYPE_MTMKB:
				return false;
			case EDeviceMtmaModel.MODULETYPE_MTMINFO:
				return false;
			case EDeviceMtmaModel.MODULETYPE_MTMAC:
				return true;
			case EDeviceMtmaModel.MODULETYPE_MTM8C:
				return false;
			case EDeviceMtmaModel.MODULETYPE_MTMBFVS:
				return false;
			case EDeviceMtmaModel.MODULETYPE_MTMDY:
				return false;
			default:
				return false;
		}
	}

	imageSource(module: MtmaModule): string {
		if (module.Type === MtmaModuleType.MTM8C || module.Type === MtmaModuleType.MTMAC) {
			return 'assets/images/mtma/mtm_black_' + module.Type + '_' + module.Config.Layout + '.svg';
		}
		return 'assets/images/mtma/mtm_black_' + module.Type + '_0.svg';
	}

	isModuleNotDelete(module: MtmaModule): boolean {
		switch (module.Type) {
			case EDeviceMtmaModel.MODULETYPE_MTMAC:
				return true;
			default:
				return false;
		}
	}

	disableEditModule(): boolean {
		if (this.isActiveTask || (!this.isTechnician && !this.isImpersMode)) {
			return true;
		}
		return false;
	}

	editModule(module: MtmaModule) {
		switch (module.Type) {
			case EDeviceMtmaModel.MODULETYPE_MTMRFID:
				this.openEditMtmRFID(module);
				break;
			case EDeviceMtmaModel.MODULETYPE_MTMKB:
				this.openEditMtmKB(module);
				break;
			case EDeviceMtmaModel.MODULETYPE_MTMINFO:
				this.openEditMtmINFO(module);
				break;
			case EDeviceMtmaModel.MODULETYPE_MTMAC:
				this.openEditMtmAC(module);
				break;
			case EDeviceMtmaModel.MODULETYPE_MTM8C:
				this.openEditMtm8C(module);
				break;
			case EDeviceMtmaModel.MODULETYPE_MTMBFVS:
				this.openEditMtmBFVS(module);
				break;
			case EDeviceMtmaModel.MODULETYPE_MTMDY:
				this.openEditMtmDY(module);
				break;
			default:
		}
	}

	openEditMtmAC(module: MtmaModule) {
		this.store.dispatch(DeviceActions.resetEditMtmaModule());
		this.ref = this.dialogService.open(MtmaManageModuleAcComponent, {
			header: this.translate.instant('EDIT_MTMAC'),
			width: '75vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				module: module
			}
		});
	}

	openEditMtmRFID(module: MtmaModule) {
		this.store.dispatch(DeviceActions.resetEditMtmaModule());
		this.ref = this.dialogService.open(MtmaManageModuleRfidComponent, {
			header: this.translate.instant('EDIT_MTMRFID'),
			width: '75vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				module: module
			}
		});
	}

	openEditMtmKB(module: MtmaModule) {
		this.store.dispatch(DeviceActions.resetEditMtmaModule());
		this.ref = this.dialogService.open(MtmaManageModuleKbComponent, {
			header: this.translate.instant('EDIT_MTMKB'),
			width: '75vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				module: module
			}
		});
	}

	openEditMtmINFO(module: MtmaModule) {
		this.store.dispatch(DeviceActions.resetEditMtmaModule());
		this.ref = this.dialogService.open(MtmaManageModuleInfoComponent, {
			header: this.translate.instant('EDIT_MTMINFO'),
			width: '75vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				module: module
			}
		});
	}

	openEditMtm8C(module: MtmaModule) {
		this.store.dispatch(DeviceActions.resetEditMtmaModule());
		this.ref = this.dialogService.open(MtmaManageModule8CComponent, {
			header: this.translate.instant('EDIT_MTM8C'),
			width: '75vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				module: module
			}
		});
	}

	openEditMtmBFVS(module: MtmaModule) {
		this.store.dispatch(DeviceActions.resetEditMtmaModule());
		this.ref = this.dialogService.open(MtmaManageModuleBfvsComponent, {
			header: this.translate.instant('EDIT_MTMBFVS'),
			width: '75vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				module: module
			}
		});
	}

	openEditMtmDY(module: MtmaModule) {
		this.store.dispatch(DeviceActions.resetEditMtmaModule());
		this.ref = this.dialogService.open(MtmaManageModuleDyComponent, {
			header: this.translate.instant('EDIT_MTMDY'),
			width: '75vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				module: module
			}
		});
	}

	deleteModule(module: MtmaModule) {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('DELETE_MTMA_MODULE'),
			message: this.translate.instant('DELETE_MTMA_MODULE_WARNING'),
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => {
				this.store.dispatch(DeviceActions.deleteMtmaModule({ moduleId: module.Id }));
			},
			reject: () => {
			}
		});
	}

	disableAddModule(): boolean {
		if (this.isActiveTask || (!this.isTechnician && !this.isImpersMode)) {
			return true;
		}
		return false;
	}

	offline(): boolean {
		return !this.deviceStatus?.Online;
	}

	onFirmwareUpdate(): boolean {
		return this.deviceStatus.FwUpdate === CLOUD_FW_UPGRADE_STATE.CLOUD_FW_UPGRADE_STATE_STARTED ||
			this.deviceStatus.FwUpdate === CLOUD_FW_UPGRADE_STATE.CLOUD_FW_UPGRADE_STATE_UPDATING;
	}

	clickAddModule() {
		this.ref = this.dialogService.open(MtmaManageModuleAddComponent, {
			header: this.translate.instant('ADD_MODULE'),
			contentStyle: {
				overflow: 'auto'
			},
		});
	}

	clickUpdateFirmwareTimeslots() {
		this.ref = this.dialogService.open(UpdateFirmwareTimeslotsDialogComponent, {
			header: this.translate.instant('MTMA_FW_AUTOUPDATE_INFO_LABEL'),
			width: '75vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
		});
		// Refresh the auto-update timeslot info (banner state) once the dialog is closed,
		// since the API POST may not return the updated resource in Data.
		this.ref.onClose.subscribe(() => {
			this.tryRequestMtmaFwAutoUpdateTimeslots();
		});
	}

	clickUpdateFirmware() {
		this.ref = this.dialogService.open(UpdateFirmwareDialogComponent, {
			header: this.translate.instant('UPDATE_FIRWARE_MTMA'),
			width: '75vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
		});
	}

	drop(event) {
		if (event.dropIndex === event.dragIndex) {
			return;
		}
		if (event.dropIndex !== 0) {
			this.mtmaModules[event.dropIndex].Position = event.dropIndex;
			this.store.dispatch(DeviceActions.editMtmaModule({ module: this.mtmaModules[event.dropIndex] }));
		} else {
			this.store.dispatch(DeviceActions.getMtmaModules());
			this.store.dispatch(DeviceActions.editMtmaModuleFailed({ errorMessage: this.translate.instant('MTMA_MODULE_ORDER_FIRST_ERROR') }));
		}
	}

	getMtmaModulesData(): void {
		if (this.isSelectTab()) {
			let test = false;
			if (environment.apiUrl !== 'https://app.cameconnect.net/api') {
				test = true;
			}
			this.store.dispatch(DeviceActions.getMtmaModules());
			this.store.dispatch(DeviceActions.getMtmaSettingsModules());
			this.store.dispatch(DeviceActions.resetFirmwareUpdate());
			this.store.dispatch(DeviceActions.getFirmwareUpdate({ test }));
			this.tryRequestMtmaFwAutoUpdateTimeslots();
		}
	}

	isSelectTab(): boolean {
		return this.tabIndex === MtmaIndexTab.MTM_MODULES;
	}

	releaseNoteAvailableFWVersion(module: MtmaModule): Firmware[] {
		switch (module.Type) {
			case EDeviceMtmaModel.MODULETYPE_MTMRFID:
				return this.releaseNoteAvailableFWVersionModule('mtmrfid');
			case EDeviceMtmaModel.MODULETYPE_MTMKB:
				return this.releaseNoteAvailableFWVersionModule('mtmkb');
			case EDeviceMtmaModel.MODULETYPE_MTMINFO:
				return this.releaseNoteAvailableFWVersionModule('mtminfo');
			case EDeviceMtmaModel.MODULETYPE_MTMAC:
				return this.releaseNoteAvailableFWVersionMtmac();
			case EDeviceMtmaModel.MODULETYPE_MTM8C:
				return this.releaseNoteAvailableFWVersionModule('mtm8c');
			case EDeviceMtmaModel.MODULETYPE_MTMBFVS:
				return this.releaseNoteAvailableFWVersionModule('mtmbfvs');
			case EDeviceMtmaModel.MODULETYPE_MTMDY:
				return this.releaseNoteAvailableFWVersionModule('mtmdy');
			default:
				return [];
		}
	}

	releaseNoteAvailableFWVersionMtmac(): Firmware[] {
		if (this.deviceModel === undefined) {
			return [];
		}
		let typeMtm = 'mtmac';
		if (isMtmacUsModel(this.deviceModel.Id)) {
			typeMtm = 'mtmacus';
		}
		if (this.automationsFirmwaresList !== undefined && this.automationsFirmwaresList.gateways !== undefined &&
			this.automationsFirmwaresList.gateways[typeMtm] !== undefined && this.automationsFirmwaresList.gateways[typeMtm][0] !== undefined
		) {
			return this.automationsFirmwaresList.gateways[typeMtm][0].sort(
				(a, b) => this.compareVersions(b.version, a.version));
		}
		return [];
	}

	releaseNoteAvailableFWVersionModule(typeModule: string): Firmware[] {
		if (this.automationsFirmwaresList !== undefined && this.automationsFirmwaresList.videoentrysystems !== undefined &&
			this.automationsFirmwaresList.videoentrysystems[typeModule] !== undefined && this.automationsFirmwaresList.videoentrysystems[typeModule][0] !== undefined
		) {
			return this.automationsFirmwaresList.videoentrysystems[typeModule][0].sort(
				(a, b) => this.compareVersions(b.version, a.version));
		}
		return [];
	}

	releaseNoteAvailableFWVersionLte(): Firmware[] {
		if (this.deviceModel === undefined) {
			return [];
		}
		let typeMtm = 'mtmaclte';
		if (isMtmacUsModel(this.deviceModel.Id)) {
			typeMtm = 'mtmacuslte';
		}
		if (this.automationsFirmwaresList !== undefined && this.automationsFirmwaresList.videoentrysystems !== undefined &&
			this.automationsFirmwaresList.videoentrysystems[typeMtm] !== undefined && this.automationsFirmwaresList.videoentrysystems[typeMtm][0] !== undefined
		) {
			return this.automationsFirmwaresList.videoentrysystems[typeMtm][0].sort(
				(a, b) => this.compareVersions(b.version, a.version));
		}
		return [];
	}


	showReleaseNoteFWVersion(module: MtmaModule): void {
		const releaseNoteList = this.releaseNoteAvailableFWVersion(module);
		this.ref = this.dialogService.open(ReleaseNoteDeviceDialogComponent, {
			header: this.translate.instant('RELEASE_NOTE_DEVICE'),
			width: '70vw',
			breakpoints: { '1120px': '98vw' },
			contentStyle: { overflow: 'auto' },
			closable: false,
			data: {
				releaseNoteDeviceList: releaseNoteList,
			},
		});
	}

	showReleaseNoteFWVersionLte(): void {
		const releaseNoteList = this.releaseNoteAvailableFWVersionLte();
		this.ref = this.dialogService.open(ReleaseNoteDeviceDialogComponent, {
			header: this.translate.instant('RELEASE_NOTE_DEVICE'),
			width: '70vw',
			breakpoints: { '1120px': '98vw' },
			contentStyle: { overflow: 'auto' },
			closable: false,
			data: {
				releaseNoteDeviceList: releaseNoteList,
			},
		});
	}


	compareVersions(ver1: string, ver2: string): boolean {
		// prevent missing versions v1 and/or v2
		if (!ver1) return false;
		if (!ver2) return true;

		const a = this.getReleaseNoteTitle(ver1).split('.').map(Number);
		const b = this.getReleaseNoteTitle(ver2).split('.').map(Number);

		const maxLength = Math.max(a.length, b.length);

		for (let i = 0; i < maxLength; i++) {
			const num1 = a[i] || 0; // if an element is missing, use 0 (default)
			const num2 = b[i] || 0;
			if (num1 > num2) return true;
			if (num1 < num2) return false;
		}
		//1.1.29
		//1.1.26

		//2.1.10
		//2.1.9

		return true; // if all parts are equal
	}

	getReleaseNoteTitle(version: string): string {
		if (version.search('b') > 0) {
			return version.substring(0, version.search('b'));
		}
		return version;
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	// actionLayout(position: string): string {
	// 	return StandardMtmaLayout.actionLayout(this.screenWidth, position);
	// }

	actionLayoutButtons(position: string): string {
		return StandardMtmaLayout.actionLayoutButtons(this.screenWidth, position);
	}
}

